<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ref } from 'vue';

import { useSearchStore } from '@nora-monorepo/ui-shared';

import ConversationSearchResults from '#nora-chat-ui/components/sidebar/search/results/ConversationSearchResults.vue';
import GroupSearchResults from '#nora-chat-ui/components/sidebar/search/results/GroupSearchResults.vue';
import MessageSearchResults from '#nora-chat-ui/components/sidebar/search/results/MessageSearchResults.vue';
import UserSearchResults from '#nora-chat-ui/components/sidebar/search/results/UserSearchResults.vue';

const searchStore = useSearchStore();

const { lastQuery, searchResults, showDetailView, detailView }
  = storeToRefs(searchStore);

const resultContainer = ref<HTMLElement>();
</script>

<template>
  <div
    ref="resultContainer"
    class="flex flex-col overflow-x-hidden overflow-y-auto"
  >
    <ConversationSearchResults
      v-if="!showDetailView || detailView === 'conversations'"
      :results="searchResults.conversations.results"
      :pagination="searchResults.conversations.pagination"
      :query="lastQuery"
      :searching="searchResults.conversations.searching"
      :result-container="resultContainer"
    />
    <MessageSearchResults
      v-if="!showDetailView || detailView === 'messages'"
      :results="searchResults.messages.results"
      :pagination="searchResults.messages.pagination"
      :searching="searchResults.messages.searching"
      :query="lastQuery"
      :result-container="resultContainer"
    />
    <GroupSearchResults
      v-if="!showDetailView || detailView === 'groups'"
      :results="searchResults.groups.results"
      :pagination="searchResults.groups.pagination"
      :searching="searchResults.groups.searching"
      :query="lastQuery"
      :result-container="resultContainer"
    />
    <UserSearchResults
      v-if="!showDetailView || detailView === 'users'"
      :results="searchResults.users.results"
      :pagination="searchResults.users.pagination"
      :searching="searchResults.users.searching"
      :query="lastQuery"
      :result-container="resultContainer"
    />
  </div>
</template>
